module.exports = __webpack_public_path__ + "static/img/contant_1.316615e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_5/contant_1.jpg
// module id = Qsei
// module chunks = 0